import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import ui_control from "./ui_control";

export default combineReducers({
  auth,
  message,
  ui_control,
});
